
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55 55"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"2.4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M53.5 18.857L39.939 28H28.638M53.5 23.437L39.939 32.58H28.638M53.5 27.991l-13.561 9.143H28.638M53.5 32.571l-13.561 9.143H28.638"}}),_c('path',{attrs:{"d":"M28.622 44H12.801V22.286L26.362 12h15.822L28.622 22.286V44zM12.801 27.991H1.5m11.301 4.58H1.5m11.301 4.581H1.5m11.301 4.554H1.5"}}),_c('path',{attrs:{"d":"M39.186 14.277H53.5L39.939 23.42H28.638m-15.822 0h-11.3l13.56-9.143h8.288"}})])])
          )
        }
      }
    